export default __webpack_public_path__ + "static/media/closeUpBee.ed5a1d84.jpg";